import { createFileRoute } from '@tanstack/react-router';
import { ActivityTable } from '@client/components/admin/activity-table';

export const Route = createFileRoute('/admin/rooms/$id/activity')({
  component: () => {
    const { id } = Route.useParams();
    return <div className="px-6 py-6 md:px-8"><ActivityTable fixed={{ room_id: id }} showExport /></div>;
  },
});
